/**
 * Challenge-Tool: "Erkennst du den Angriff?"
 *
 * Läuft vollständig im Browser, kein Backend. Szenarien stecken als Daten in
 * SZENARIEN, damit weitere ohne Code-Änderung ergänzt werden können.
 *
 * Zwei Typen:
 *   "quiz"     – Logauszüge + Fragen mit Auswahlantworten (Log-Analyse)
 *   "inspect"  – eine E-Mail, in der verdächtige Stellen angeklickt werden
 *                (Phishing-Erkennung)
 *
 * Es wird nichts gespeichert oder übertragen. Die E-Mail-Anmeldung am Ende
 * übernimmt Ghosts Portal (Member-Signup), nicht dieses Skript.
 */
(function () {
    'use strict';

    var root = document.querySelector('[data-challenge]');
    if (!root) {
        return;
    }

    /* --------------------------------------------------------- Szenario-Daten
     * Bewusst hier im Skript statt in einer zweiten Datei: gulp concatet
     * assets/js/*.js alphabetisch, eine "challenge-data.js" käme nach dieser
     * Datei und wäre zum Ausführungszeitpunkt noch nicht geladen.
     * Weitere Szenarien hier als Schlüssel ergänzen; der Slug im Template
     * (data-challenge="…") wählt aus.
     */
    var SZENARIEN = {

        'log-analyse': {
            typ: 'serie',
            einheit: 'Log',
            runden: [

                /* ---- Log 1: Lateral Movement bis DCSync ---- */
                {
                    label: 'Der Weg zum Domaincontroller',
                    intro: 'Du sitzt im SOC. Vor dir liegen Einträge aus dem Windows-' +
                        'Sicherheitsprotokoll einer Workstation (WS-FINANZ-07) und des ' +
                        'Domaincontrollers (DC01). Lies von oben nach unten – und finde die Kette.',
                    logs:
'====================================================================\n' +
' Protokoll: Sicherheit     Quelle: Microsoft-Windows-Security-Auditing\n' +
'====================================================================\n' +
'\n' +
'07.10. 10:02:14  4624  WS-FINANZ-07   Anmeldung erfolgreich\n' +
'   Anmeldetyp: 2 (Interaktiv)   Konto: NORDWIND\\m.weber\n' +
'\n' +
'07.10. 10:03:48  4688  WS-FINANZ-07   Neuer Prozess\n' +
'   powershell.exe -nop -w hidden -enc JABzAD0ATgBlAHcALQBPAGIA...\n' +
'\n' +
'07.10. 10:04:01  4648  WS-FINANZ-07   Anmeldung mit expliziten Anmeldeinfos\n' +
'   Aufrufer: NORDWIND\\m.weber   Ziel: svc-backup   Server: DC01.nordwind.local\n' +
'\n' +
'07.10. 10:04:02  4624  DC01   Anmeldung erfolgreich\n' +
'   Anmeldetyp: 3 (Netzwerk)   Konto: NORDWIND\\svc-backup   Quelle: WS-FINANZ-07\n' +
'\n' +
'07.10. 10:04:55  4672  DC01   Besondere Rechte zugewiesen\n' +
'   Konto: NORDWIND\\svc-backup   SeDebugPrivilege, SeBackupPrivilege\n' +
'\n' +
'07.10. 10:06:31  4662  DC01   Vorgang auf Objekt\n' +
'   Konto: NORDWIND\\svc-backup   Eigenschaft: DS-Replication-Get-Changes-All\n' +
'\n' +
'07.10. 10:07:10  4688  DC01   Neuer Prozess\n' +
'   ntdsutil "ac i ntds" "ifm" "create full C:\\temp\\x" q q',
                    fragen: [
                        {
                            frage: 'Welches Konto wird für den Angriff missbraucht?',
                            optionen: ['m.weber – der angemeldete Mitarbeiter',
                                'svc-backup – ein Dienstkonto',
                                'DC01 – das Computerkonto des Domaincontrollers'],
                            richtig: 1,
                            erklaerung: 'Nach dem Login von m.weber wird über 4648 auf svc-backup ' +
                                'gewechselt. Ein Dienstkonto, das sich am DC anmeldet (Typ 3) und ' +
                                'Sonderrechte erhält, ist der rote Faden.'
                        },
                        {
                            frage: 'Was bedeutet das PowerShell-Ereignis (-enc …)?',
                            optionen: ['Ein normales Administrationsskript',
                                'Ein Base64-kodierter Befehl – typisch zur Verschleierung',
                                'Ein Windows-Update-Vorgang'],
                            richtig: 1,
                            erklaerung: 'powershell -enc führt einen Base64-kodierten Befehl aus. ' +
                                'Angreifer nutzen das, um den eigentlichen Befehl vor einfachem ' +
                                'Logging zu verstecken.'
                        },
                        {
                            frage: '4662 (DS-Replication-Get-Changes-All) und ntdsutil auf DC01 – ' +
                                'worauf deutet das?',
                            optionen: ['Reguläre Replikation zwischen Domaincontrollern',
                                'Ein DCSync bzw. Kopieren der AD-Datenbank – Diebstahl aller Hashes',
                                'Ein Backup-Job des Dienstkontos'],
                            richtig: 1,
                            erklaerung: 'DS-Replication-Get-Changes-All ist das Replikationsrecht, das ' +
                                'DCSync missbraucht, um Passwort-Hashes abzuziehen. ntdsutil "ifm" kopiert ' +
                                'zusätzlich die komplette NTDS.dit. Spätestens jetzt ist die Domäne kompromittiert.'
                        }
                    ]
                },

                /* ---- Log 2: Password-Spray mit Durchbruch ---- */
                {
                    label: 'Viele Türen, ein Treffer',
                    intro: 'Neuer Fall, anderer Server: das RDP-Gateway (WS-RDP-GW). Der Auszug ' +
                        'wirkt auf den ersten Blick nach Tippfehlern von Mitarbeitern. Sieh genauer hin.',
                    logs:
'====================================================================\n' +
' Protokoll: Sicherheit     Host: WS-RDP-GW\n' +
'====================================================================\n' +
'\n' +
'08.10. 22:14:03  4625  Fehler bei Anmeldung  Konto: a.meier   Quelle: 203.0.113.66   0xC000006A\n' +
'08.10. 22:14:06  4625  Fehler bei Anmeldung  Konto: m.weber   Quelle: 203.0.113.66   0xC000006A\n' +
'08.10. 22:14:09  4625  Fehler bei Anmeldung  Konto: s.braun   Quelle: 203.0.113.66   0xC000006A\n' +
'08.10. 22:14:12  4625  Fehler bei Anmeldung  Konto: t.koch    Quelle: 203.0.113.66   0xC000006A\n' +
'08.10. 22:14:15  4625  Fehler bei Anmeldung  Konto: j.vogel   Quelle: 203.0.113.66   0xC000006A\n' +
'   ... (41 weitere Konten, je genau 1 Versuch, alle von 203.0.113.66) ...\n' +
'08.10. 22:19:40  4625  Fehler bei Anmeldung  Konto: r.lang    Quelle: 203.0.113.66   0xC000006A\n' +
'08.10. 22:19:42  4624  Anmeldung ERFOLGREICH Konto: p.schulz  Quelle: 203.0.113.66   Typ 3\n' +
'08.10. 22:21:00  4624  Anmeldung ERFOLGREICH Konto: p.schulz  Quelle: 45.9.148.37    Typ 10 (RDP)\n' +
'   Hinweis: 0xC000006A = falsches Kennwort',
                    fragen: [
                        {
                            frage: 'Was beschreibt das Muster der vielen 4625-Ereignisse?',
                            optionen: ['Ein Brute-Force gegen ein einzelnes Konto',
                                'Ein Password-Spray: ein Kennwort gegen viele Konten, je nur ein Versuch',
                                'Normale vergessene Kennwörter am Morgen'],
                            richtig: 1,
                            erklaerung: 'Viele verschiedene Konten, von derselben IP, je genau EIN ' +
                                'Fehlversuch – das ist ein Password-Spray. Ein Versuch pro Konto umgeht ' +
                                'die Kontosperre, die bei Brute-Force gegen ein Konto greifen würde.'
                        },
                        {
                            frage: 'Welche Zeile markiert den Durchbruch?',
                            optionen: ['Der erste 4625-Eintrag um 22:14:03',
                                'Das 4624 (ERFOLG) für p.schulz um 22:19:42',
                                'Es gab keinen erfolgreichen Zugriff'],
                            richtig: 1,
                            erklaerung: 'Nach der Serie von Fehlversuchen meldet sich p.schulz um 22:19:42 ' +
                                'erfolgreich an – von genau der IP, die eben noch sprühte. Ein Treffer reicht.'
                        },
                        {
                            frage: 'Warum ist die Zeile um 22:21:00 besonders alarmierend?',
                            optionen: ['RDP-Anmeldung (Typ 10) von einer ganz anderen, fremden IP – ' +
                                'der Angreifer nutzt das Konto jetzt interaktiv',
                                'Weil p.schulz sich zweimal angemeldet hat',
                                'Gar nicht – Typ 10 ist eine normale lokale Anmeldung'],
                            richtig: 0,
                            erklaerung: 'Direkt nach dem Treffer folgt eine interaktive RDP-Anmeldung ' +
                                '(Typ 10) von 45.9.148.37 – einer neuen, externen Adresse. Der Angreifer ' +
                                'hat sich eingeloggt. p.schulz gehört sofort gesperrt und die Sitzung getrennt.'
                        }
                    ]
                },

                /* ---- Log 3: Persistenz ---- */
                {
                    label: 'Damit es bleibt',
                    intro: 'Dritter Fall, nachts auf WS-FINANZ-07 und DC01. Der Einbruch liegt bereits ' +
                        'zurück – jetzt sorgt der Angreifer dafür, dass er den Zugang behält. Woran siehst du das?',
                    logs:
'====================================================================\n' +
' Protokoll: Sicherheit\n' +
'====================================================================\n' +
'\n' +
'09.10. 03:01:12  4688  WS-FINANZ-07   Neuer Prozess\n' +
'   schtasks.exe /create /sc minute /mo 10 /tn "OneDriveSync"\n' +
'            /tr "powershell -enc ..." /ru SYSTEM\n' +
'\n' +
'09.10. 03:01:40  7045  WS-FINANZ-07   Ein Dienst wurde installiert\n' +
'   Dienstname: WinTelemetrySvc   Pfad: C:\\ProgramData\\wts\\svc.exe\n' +
'\n' +
'09.10. 03:02:05  4720  DC01   Ein Benutzerkonto wurde erstellt\n' +
'   Neues Konto: NORDWIND\\support_adm\n' +
'\n' +
'09.10. 03:02:06  4732  DC01   Mitglied zu Gruppe hinzugefügt\n' +
'   Gruppe: Administratoren   Mitglied: NORDWIND\\support_adm',
                    fragen: [
                        {
                            frage: 'Was bewirken der geplante Task („OneDriveSync") und der neue Dienst?',
                            optionen: ['Sie synchronisieren Dateien in die Cloud',
                                'Persistenz: der Angriffscode startet immer wieder und überlebt Neustarts',
                                'Sie sind Teil eines normalen Windows-Updates'],
                            richtig: 1,
                            erklaerung: 'Ein geplanter Task, der alle 10 Minuten als SYSTEM PowerShell ' +
                                'startet, und ein neu installierter Dienst sind klassische Persistenz: der ' +
                                'Zugang bleibt auch nach Neustart oder Abmeldung bestehen. Die harmlosen Namen ' +
                                '(OneDriveSync, WinTelemetrySvc) sind Tarnung.'
                        },
                        {
                            frage: 'Was ist mit 4720 und 4732 auf dem DC passiert?',
                            optionen: ['Ein normaler neuer Mitarbeiter wurde angelegt',
                                'Ein neues Konto wurde erstellt und direkt in die Administratoren-Gruppe ' +
                                'aufgenommen – eine Hintertür',
                                'Ein bestehendes Konto wurde nur umbenannt'],
                            richtig: 1,
                            erklaerung: '4720 = Konto erstellt, 4732 = dieses Konto in die Gruppe ' +
                                'Administratoren aufgenommen – nachts, automatisiert, mit unauffälligem Namen ' +
                                '(support_adm). Ein zweiter, dauerhafter Admin-Zugang als Rückfalltür.'
                        },
                        {
                            frage: 'Was ist jetzt der erste richtige Schritt?',
                            optionen: ['Nur den geplanten Task löschen und weitermachen',
                                'Betroffene Hosts isolieren, alle Persistenz (Task, Dienst, Konto) entfernen ' +
                                'und als Vorfall behandeln – inklusive Suche nach weiteren Hintertüren',
                                'Das neue Admin-Konto behalten, falls es doch legitim ist'],
                            richtig: 1,
                            erklaerung: 'Einzelne Artefakte zu löschen reicht nicht – Angreifer legen meist ' +
                                'mehrere Rückfalltüren. Hosts isolieren, alle gefundene Persistenz entfernen, ' +
                                'das fremde Admin-Konto deaktivieren und gezielt nach weiteren suchen.'
                        }
                    ]
                }

            ],
            abschlussfragen: [
                {
                    frage: 'Und im Arbeitsalltag: Wie fallen solche Ketten auf, bevor jemand zufällig ' +
                        'die Logs liest?',
                    optionen: [
                        'Windows meldet so etwas von selbst per Pop-up am Domaincontroller.',
                        'Gar nicht zuverlässig – man muss die Ereignisanzeige eben regelmäßig durchsehen.',
                        'Die Logs laufen zentral zusammen (SIEM), Korrelationsregeln und ' +
                            'Verhaltensanalyse schlagen bei solchen Mustern Alarm, und ein SOC bewertet sie.'
                    ],
                    richtig: 2,
                    erklaerung: 'Einzelne Events wie 4624, 4688 oder 4662 fallen pro Tag tausendfach an – ' +
                        'von Hand findet man die bösartige Kette darin nicht. Was trägt: zentrale Sammlung ' +
                        '(SIEM), Regeln, die z. B. „Password-Spray", „DCSync" oder „neues Admin-Konto nachts" ' +
                        'erkennen, ergänzt um Endpoint-Telemetrie (EDR) – und Menschen, die die Alarme ' +
                        'bewerten. Genau das leistet ein Security Operations Center.'
                }
            ],
            ergebnis: {
                gut: 'Drei Angriffe, drei Techniken – Lateral Movement bis DCSync, Password-Spray und ' +
                    'Persistenz – und du hast die Ketten gelesen. Genau dieser Blick entscheidet, ob ein ' +
                    'Vorfall in Minuten oder erst nach Wochen auffällt.',
                mittel: 'Die Richtung stimmt, aber einzelne Glieder sind durchgerutscht – und im Ernstfall ' +
                    'zählt jedes einzelne.',
                schwach: 'Diese Ketten sind bewusst schwer. Dass sie schwer zu lesen sind, ist genau der ' +
                    'Grund, warum Angriffe im Schnitt monatelang unentdeckt bleiben.'
            }
        },

        'phishing': {
            typ: 'serie',
            einheit: 'Mail',
            // Firma "Musterbau" ist fiktiv. Mails sind reine Anzeige: nichts ist
            // anklickbar, der Link zeigt sein echtes Ziel nur beim Überfahren.
            runden: [

                /* ---- Mail 1: der plumpe Klassiker ---- */
                {
                    label: 'Der plumpe Klassiker',
                    intro: 'Diese Mail liegt in deinem Postfach. Lies sie, klapp bei Bedarf die ' +
                        'E-Mail-Header auf, und kreuze unten an, was gefährlich ist. Diese hier ist ' +
                        'noch leicht zu durchschauen – aber was genau verrät sie?',
                    mailHtml:
'<div class="chl-mail-head">' +
  '<div class="chl-mail-row"><span class="chl-mail-k">Von</span>' +
    '<span class="chl-mail-v">Microsoft-Konto-Team ' +
    '<span class="chl-mail-addr">&lt;security@micr0soft-support.com&gt;</span></span></div>' +
  '<div class="chl-mail-row"><span class="chl-mail-k">Antwort an</span>' +
    '<span class="chl-mail-v">no-reply@account-verify-secure.ru</span></div>' +
  '<div class="chl-mail-row"><span class="chl-mail-k">Betreff</span>' +
    '<span class="chl-mail-v">Ihr Konto wird in 24 Stunden GESPERRT!</span></div>' +
'</div>' +
'<div class="chl-mail-body">' +
  '<p>Sehr geehrter Nutzer,</p>' +
  '<p>wir haben eine ungewöhnliche Anmeldung festgestellt. Aus Sicherheitsgründen wird Ihr ' +
  'Konto <strong>innerhalb von 24 Stunden gesperrt</strong>, wenn Sie es nicht sofort ' +
  'bestätigen.</p>' +
  '<p>Bitte bestätigen Sie hier umgehend Ihre Identität: ' +
  '<span class="chl-link" data-real="http://account-verify-secure.ru/login?id=88213">' +
     'https://account.microsoft.com/sicherheit</span></p>' +
  '<p>Mit freundlichen Grüßen<br>Ihr Microsoft-Sicherheitsteam</p>' +
'</div>',
                    header:
'From: "Microsoft-Konto-Team" <security@micr0soft-support.com>\n' +
'Reply-To: no-reply@account-verify-secure.ru\n' +
'Authentication-Results: mx.firma.de;\n' +
'          spf=fail (micr0soft-support.com: sender not authorized)\n' +
'          dkim=none;  dmarc=fail',
                    pruefpunkte: [
                        {gefahr: true, text: 'Die Absenderdomain ist micr0soft-support.com – mit Null ' +
                            'statt „o" und gar nicht microsoft.com.',
                         erklaerung: 'Gleich doppelt falsch: die Null im Namen und eine Domain, die ' +
                            'nichts mit Microsoft zu tun hat. Große Anbieter schreiben nie von solchen Adressen.'},
                        {gefahr: true, text: 'Die Antwortadresse geht an no-reply@account-verify-secure.ru ' +
                            '– eine ganz andere, fremde Domain als der Absender.',
                         erklaerung: 'Hier weicht die Antwortadresse vom Absender ab und führt zu einer ' +
                            'fremden .ru-Domain. Lohnt immer den Blick: Wohin ginge deine Antwort wirklich?'},
                        {gefahr: true, text: 'Der Link zeigt account.microsoft.com, führt laut ' +
                            'Statusleiste aber auf account-verify-secure.ru.',
                         erklaerung: 'Linktext und echtes Ziel klaffen auseinander. Maßgeblich ist das ' +
                            'echte Ziel (beim Überfahren sichtbar) – hier eine fremde .ru-Domain.'},
                        {gefahr: true, text: 'Drohung mit Kontosperre und eine Frist von 24 Stunden.',
                         erklaerung: 'Künstlicher Zeitdruck mit Droh-Szenario soll zu unüberlegtem ' +
                            'Klicken verleiten. Seriöse Anbieter arbeiten nicht mit solchen Ultimaten.'},
                        {gefahr: true, text: 'Unpersönliche Anrede „Sehr geehrter Nutzer".',
                         erklaerung: 'Der echte Konto-Anbieter kennt deinen Namen. Eine anonyme ' +
                            'Massenanrede passt zu einem breit gestreuten Phishing.'},
                        {gefahr: false, text: 'Die Mail ist in fehlerfreiem Deutsch geschrieben.',
                         erklaerung: 'Gutes Deutsch ist heute kein Echtheitsbeweis – moderne Angriffe sind ' +
                            'sprachlich sauber. Für sich genommen kein Warnzeichen.'},
                        {gefahr: false, text: 'Die Mail enthält einen Button bzw. Link zum Anklicken.',
                         erklaerung: 'Dass eine Mail einen Link enthält, ist normal. Gefährlich ist nicht ' +
                            'der Link an sich, sondern wohin er führt.'}
                    ]
                },

                /* ---- Mail 2: die getarnte Rechnung (BEC) ---- */
                {
                    label: 'Die getarnte Rechnung',
                    intro: 'Jetzt wird es schwerer. Du bist in der Buchhaltung der Musterbau GmbH. ' +
                        'Diese Mail kommt scheinbar von einem langjährigen Lieferanten – und selbst die ' +
                        'Absenderprüfung geht glatt durch. Warum solltest du trotzdem nicht zahlen?',
                    mailHtml:
'<div class="chl-mail-head">' +
  '<div class="chl-mail-row"><span class="chl-mail-k">Von</span>' +
    '<span class="chl-mail-v">Musterbau GmbH – Buchhaltung ' +
    '<span class="chl-mail-addr">&lt;buchhaltung@musterbau-gmbh.de&gt;</span></span></div>' +
  '<div class="chl-mail-row"><span class="chl-mail-k">Antwort an</span>' +
    '<span class="chl-mail-v">buchhaltung@musterbau-gmbh.de</span></div>' +
  '<div class="chl-mail-row"><span class="chl-mail-k">Betreff</span>' +
    '<span class="chl-mail-v">Rechnung R-2026-4471 · Zahlung bis 20.10.</span></div>' +
'</div>' +
'<div class="chl-mail-body">' +
  '<p>Sehr geehrte Frau Krüger,</p>' +
  '<p>anbei unsere Rechnung R-2026-4471 über die letzte Lieferung (Stahlträger, ' +
  'Lieferschein LS-3390). Wie gewohnt bitten wir um Begleichung innerhalb von 14 Tagen.</p>' +
  '<p><strong>Kurzer Hinweis:</strong> Zum 01.10. haben wir die Bank gewechselt. Bitte ' +
  'überweise auf unsere neue Verbindung – ' +
  'IBAN DE21 5001 0517 0648 4898 90. Die alte Kontoverbindung wird nicht mehr geführt.</p>' +
  '<p>Die vollständige Rechnung findest du hier: ' +
  '<span class="chl-link" data-real="https://musterbau.de.kundenrechnung-portal.com/inv/4471/view">' +
     'https://musterbau.de/rechnungen/R-2026-4471</span></p>' +
  '<p>Mit freundlichen Grüßen<br>Andrea Sailer<br>Buchhaltung · Musterbau GmbH<br>' +
  'Tel. 07123 456-0</p>' +
'</div>',
                    header:
'Received: from mta-04.musterbau-gmbh.de (203.0.113.42)\n' +
'          by mx.musterbau.de; Tue, 7 Oct 2026 09:58:11 +0200\n' +
'From: "Musterbau GmbH - Buchhaltung" <buchhaltung@musterbau-gmbh.de>\n' +
'Reply-To: buchhaltung@musterbau-gmbh.de\n' +
'Authentication-Results: mx.musterbau.de;\n' +
'          spf=pass (sender 203.0.113.42 authorized for musterbau-gmbh.de)\n' +
'          dkim=pass header.d=musterbau-gmbh.de;\n' +
'          dmarc=pass header.from=musterbau-gmbh.de',
                    pruefpunkte: [
                        {gefahr: true, text: 'Die Absenderdomain lautet musterbau-gmbh.de, obwohl der ' +
                            'echte Lieferant musterbau.de nutzt.',
                         erklaerung: 'Das angehängte „-gmbh" sieht plausibel aus, ist aber eine andere, ' +
                            'vom Angreifer registrierte Domain. Absenderadressen Zeichen für Zeichen mit ' +
                            'einer früheren echten Mail vergleichen.'},
                        {gefahr: true, text: 'Der Link zeigt musterbau.de, führt laut Statusleiste aber ' +
                            'auf kundenrechnung-portal.com.',
                         erklaerung: 'Maßgeblich ist die Domain direkt vor dem ersten „/": hier ' +
                            'kundenrechnung-portal.com. „musterbau.de" ist nur eine Subdomain davor – Tarnung.'},
                        {gefahr: true, text: 'Es wird eine kurzfristig geänderte Bankverbindung ' +
                            '(neue IBAN) mitgeteilt.',
                         erklaerung: 'Eine „geänderte" Kontoverbindung mit Frist ist das Kernmuster des ' +
                            'Rechnungsbetrugs (BEC). Immer über einen bekannten, separaten Kanal telefonisch ' +
                            'bestätigen – nie über Kontaktdaten aus der Mail.'},
                        {gefahr: true, text: 'In den Headern steht überall „pass", aber geprüft wurde die ' +
                            'gefälschte Domain musterbau-gmbh.de.',
                         erklaerung: 'SPF/DKIM/DMARC bestätigen nur, dass der Absender SEINE Domain ' +
                            'kontrolliert – nicht, dass er der echte Lieferant ist. „pass" für die falsche ' +
                            'Domain ersetzt die Prüfung nicht.'},
                        {gefahr: false, text: 'Die Antwortadresse ist identisch mit dem Absender.',
                         erklaerung: 'Das ist erwartbar und hier kein Problem. Oft weicht Reply-To bei ' +
                            'Betrug ab; hier nicht – das beruhigt fälschlich, ist aber kein Warnzeichen.'},
                        {gefahr: false, text: 'Die Rechnung nennt eine Zahlungsfrist von 14 Tagen.',
                         erklaerung: 'Eine gewöhnliche Frist ist unauffällig. Gefährlich ist erst die ' +
                            'Kombination mit der geänderten Bankverbindung.'}
                    ]
                },

                /* ---- Mail 3: der Chef-Betrug (CEO fraud) ---- */
                {
                    label: 'Der Anruf von ganz oben',
                    intro: 'Die schwerste Form: keine Links, keine Rechnung, kein technischer Fehler im ' +
                        'Text. Diese Mail kommt scheinbar vom Geschäftsführer persönlich. Was macht sie ' +
                        'trotzdem gefährlich?',
                    mailHtml:
'<div class="chl-mail-head">' +
  '<div class="chl-mail-row"><span class="chl-mail-k">Von</span>' +
    '<span class="chl-mail-v">Thomas Berger ' +
    '<span class="chl-mail-addr">&lt;t.berger.extern@gmail.com&gt;</span></span></div>' +
  '<div class="chl-mail-row"><span class="chl-mail-k">Antwort an</span>' +
    '<span class="chl-mail-v">t.berger.privat@gmx.net</span></div>' +
  '<div class="chl-mail-row"><span class="chl-mail-k">Betreff</span>' +
    '<span class="chl-mail-v">Kurze Bitte – vertraulich</span></div>' +
'</div>' +
'<div class="chl-mail-body">' +
  '<p>Hallo Frau Krüger,</p>' +
  '<p>ich sitze gerade in einem Termin und komme telefonisch nicht ran. Wir müssen heute ' +
  'noch eine Sache abschließen, die noch niemand wissen soll.</p>' +
  '<p>Bitte besorgen Sie 5 Apple-Gutscheinkarten à 200 €, kratzen Sie die Codes frei und ' +
  'schicken Sie mir Fotos davon per Mail. Es ist dringend und vertraulich – bitte wenden Sie ' +
  'sich nicht an die Kollegen, ich erkläre alles später.</p>' +
  '<p>Danke und viele Grüße<br>Thomas Berger<br>Geschäftsführung</p>' +
  '<p style="color:#888">Von meinem iPhone gesendet</p>' +
'</div>',
                    header:
'From: "Thomas Berger" <t.berger.extern@gmail.com>\n' +
'Reply-To: t.berger.privat@gmx.net\n' +
'Authentication-Results: mx.musterbau.de;\n' +
'          spf=pass (gmail.com)  dkim=pass header.d=gmail.com  dmarc=pass',
                    pruefpunkte: [
                        {gefahr: true, text: 'Der „Geschäftsführer" schreibt von einer privaten ' +
                            'Gmail-Adresse statt von seiner Firmenadresse.',
                         erklaerung: 'Die Firmenleitung schreibt dienstliche Anweisungen nicht von einer ' +
                            'frei erstellbaren Gmail-Adresse. Genau das ist der Kern des CEO-Betrugs: ein ' +
                            'bekannter Name, eine fremde Adresse.'},
                        {gefahr: true, text: 'Die Antwortadresse (gmx.net) weicht noch einmal vom ' +
                            'Absender ab.',
                         erklaerung: 'Antworten würden an eine dritte, private Adresse gehen – ein ' +
                            'deutliches Zeichen, dass hier jemand eine Identität vortäuscht.'},
                        {gefahr: true, text: 'Ungewöhnliche, dringende Bitte um Gutscheinkarten plus ' +
                            'Geheimhaltung („nicht an die Kollegen wenden").',
                         erklaerung: 'Dringlichkeit, eine untypische Zahlungsform (Gutscheinkarten) und ' +
                            'die Aufforderung zur Geheimhaltung sollen jede Rückfrage verhindern. Das ist ' +
                            'das Lehrbuchmuster des CEO-Betrugs.'},
                        {gefahr: true, text: 'Obwohl SPF/DKIM/DMARC auf „pass" stehen, ist es nur eine ' +
                            'echte Gmail – nicht der Chef.',
                         erklaerung: 'Die Prüfung bestätigt nur, dass die Mail echt von diesem Gmail-Konto ' +
                            'kommt. Dass dahinter der Geschäftsführer steckt, beweist sie gerade nicht. ' +
                            'Authentifizierung ≠ Identität der Person.'},
                        {gefahr: false, text: 'Die Mail endet mit „Von meinem iPhone gesendet".',
                         erklaerung: 'Diese Signatur kann jeder setzen; sie soll Kürze und fehlende ' +
                            'Rückfragen erklären. Für sich genommen beweist sie nichts – echte wie falsche ' +
                            'Mails tragen sie.'},
                        {gefahr: false, text: 'Die Mail spricht dich mit deinem Namen an.',
                         erklaerung: 'Namen stehen oft öffentlich im Impressum oder auf LinkedIn. Eine ' +
                            'persönliche Anrede ist heute Standard – bei echten wie bei betrügerischen Mails.'}
                    ]
                }

            ],
            abschlussfragen: [
                {
                    frage: 'Über alle drei Mails hinweg: Was schützt im Zweifel am zuverlässigsten?',
                    optionen: [
                        'Ein grünes „pass" bei SPF/DKIM/DMARC – dann ist die Mail sicher echt.',
                        'Bei ungewöhnlichen Bitten (Zahlung, Bankwechsel, Gutscheine) über einen ' +
                            'bekannten, zweiten Kanal zurückfragen – und Absender/Link-Ziel genau prüfen.',
                        'Verdächtige Mails einfach löschen und nicht weiter beachten.'
                    ],
                    richtig: 1,
                    erklaerung: 'In Mail 2 und 3 stand „pass" – trotzdem war es Betrug, weil die geprüfte ' +
                        'Domain bzw. das Konto dem Angreifer gehörte. Was wirklich trägt: bei jeder ' +
                        'ungewöhnlichen Geld- oder Datenbitte über einen separaten, bekannten Weg ' +
                        'zurückfragen (Telefonnummer aus dem eigenen Verzeichnis, nicht aus der Mail) und ' +
                        'Absenderadresse wie Link-Ziel bewusst ansehen.'
                },
                {
                    frage: 'Und organisatorisch: Womit senkt ein Unternehmen das Risiko im Alltag am meisten?',
                    optionen: [
                        'Indem man sich darauf verlässt, dass die Mitarbeitenden schon aufpassen.',
                        'Mit Technik UND Mensch: strenges DMARC gegen Spoofing der eigenen Domain, ' +
                            'ein „Melden"-Knopf im Mailprogramm, klare Freigabeprozesse für Zahlungen – ' +
                            'und regelmäßige Awareness-Schulungen.',
                        'Indem eingehende E-Mail ganz abgeschaltet wird.'
                    ],
                    richtig: 1,
                    erklaerung: 'Einzelne Wachsamkeit reicht nicht. Technisch hilft ein strenger ' +
                        'DMARC-Eintrag (damit niemand die eigene Domain fälscht), ein einfacher Melde-Knopf ' +
                        'und ein Vier-Augen-/Rückruf-Prozess bei Zahlungen und Bankänderungen. Dazu Menschen, ' +
                        'die solche Muster kennen – genau das trainiert Awareness. Technik und Mensch zusammen.'
                }
            ],
            ergebnis: {
                gut: 'Vom plumpen Fake über die getarnte Rechnung bis zum Chef-Betrug – treffsicher ' +
                    'erkannt und Harmloses stehen gelassen. Genau dieser Blick entscheidet im Alltag, ' +
                    'ob eine Betrugsmail klickt oder gelöscht wird.',
                mittel: 'Ein Teil stimmt. Übersehene Gefahren – oder Fehlalarme bei Harmlosem – kosten ' +
                    'im Alltag beides: das eine lässt Betrug durch, das andere lähmt.',
                schwach: 'Die späteren Mails sind bewusst hart: echte Authentifizierung, plausible ' +
                    'Namen, kein technischer Patzer. Genau deshalb funktioniert dieser Betrug – und genau ' +
                    'hier setzt Awareness an.'
            }
        },

        'firewall': {
            typ: 'serie',
            einheit: 'Log',
            intro: 'Auf einem eurer Webserver (WEB-01, 10.20.0.15) wurden möglicherweise Dateien ' +
                'hochgeladen, die dort nichts zu suchen haben. Du bekommst nacheinander vier ' +
                'Protokoll-Ausschnitte – von Fall zu Fall versteckter. Kreuze jeweils nur die ' +
                'wirklich gefährlichen Einträge an. Nach dem Auswerten geht es zum nächsten Log.',
            runden: [

                /* ---- Runde 1: deutliche Kette ---- */
                {
                    label: 'Der offensichtliche Fall',
                    intro: 'Ein Kollege meldet, dass auf WEB-01 eine fremde PHP-Datei ' +
                        'aufgetaucht ist. Hier das Firewall-Protokoll der Minuten danach. ' +
                        'Diesmal sind die Spuren noch deutlich – finde Einstieg, Steuerung ' +
                        'und Abfluss und lass den harmlosen Verkehr stehen.',
                    logs:
'=================================================================================\n' +
' FW-CORE   Protokoll 14:00–14:12   Host WEB-01 = 10.20.0.15\n' +
'=================================================================================\n' +
' Nr  Zeit      Ri   Ziel                 Port  Aktion  Volumen  Notiz\n' +
'---------------------------------------------------------------------------------\n' +
' 01  14:00:07  aus  10.20.0.1            53    ALLOW   0,4 KB   DNS\n' +
' 02  14:01:02  aus  20.190.160.14        443   ALLOW   180 KB   update.microsoft.com\n' +
' 03  14:02:11  aus  104.18.22.19         443   ALLOW   48 MB    cdn.jsdelivr.net\n' +
' 04  14:02:44  ein  45.133.216.78        443   ALLOW   2 KB     POST /uploads/rechnung.php -> 200\n' +
' 05  14:03:00  aus  45.133.216.78        8443  ALLOW   1,1 KB   TLS\n' +
' 06  14:04:00  aus  45.133.216.78        8443  ALLOW   1,1 KB   TLS\n' +
' 07  14:04:10  aus  91.189.91.43         123   ALLOW   0,1 KB   NTP\n' +
' 08  14:05:00  aus  45.133.216.78        8443  ALLOW   1,1 KB   TLS\n' +
' 09  14:06:00  aus  45.133.216.78        8443  ALLOW   1,1 KB   TLS\n' +
' 10  14:06:38  aus  45.133.216.78        4444  ALLOW   640 KB   -\n' +
' 11  14:07:01  aus  45.133.216.78        8443  ALLOW   1,1 KB   TLS\n' +
' 12  14:08:30  aus  45.133.216.78        8443  ALLOW   2,3 GB   -\n' +
' 13  14:09:15  aus  104.18.22.19         443   ALLOW   12 MB    cdn.jsdelivr.net',
                    pruefpunkte: [
                        {gefahr: true, text: 'Nr. 04 – POST /uploads/rechnung.php von extern, Antwort 200.',
                         erklaerung: 'Eine ausführbare PHP-Datei im Upload-Verzeichnis, die von außen ' +
                            'erfolgreich (200) angesprochen wird, ist ein klassischer Webshell-Upload – ' +
                            'der Einstiegspunkt.'},
                        {gefahr: true, text: 'Nr. 05/06/08/09/11 – alle 60 s eine kurze TLS-Verbindung zu 45.133.216.78:8443.',
                         erklaerung: 'Gleich große Verbindungen in exakt regelmäßigem Takt sind ' +
                            'C2-Beaconing: die Webshell meldet sich periodisch beim Steuerungsserver.'},
                        {gefahr: true, text: 'Nr. 10 – ausgehend zu 45.133.216.78 auf Port 4444.',
                         erklaerung: 'Port 4444 ist die Standardvorgabe von Angriffs-Frameworks ' +
                            '(z. B. Metasploit) für Reverse Shells – ein Zeichen für eine interaktive Sitzung.'},
                        {gefahr: true, text: 'Nr. 12 – 2,3 GB ausgehend zu 45.133.216.78.',
                         erklaerung: 'Großer Abfluss zu genau der Beacon-Adresse: sehr wahrscheinlich ' +
                            'Datenexfiltration. Von einem Webserver besonders auffällig.'},
                        {gefahr: false, text: 'Nr. 03 – 48 MB zu cdn.jsdelivr.net auf 443.',
                         erklaerung: 'Großes Volumen, aber bekanntes CDN auf Standard-HTTPS – normaler ' +
                            'Verkehr. Volumen allein macht nichts gefährlich.'},
                        {gefahr: false, text: 'Nr. 02 – zu update.microsoft.com auf 443.',
                         erklaerung: 'Reguläre Update-Verbindung. Unauffällig.'},
                        {gefahr: false, text: 'Nr. 07 – Port 123 (NTP).',
                         erklaerung: 'Zeitsynchronisation, normaler Hintergrundverkehr.'}
                    ]
                },

                /* ---- Runde 2: über Standardports getarnt ---- */
                {
                    label: 'Getarnt im Normalverkehr',
                    intro: 'Zweiter Fall, nachts kurz nach zwei. Der Angreifer meidet diesmal ' +
                        'auffällige Ports und versteckt sich in Diensten, die ohnehin immer ' +
                        'erlaubt sind: DNS, HTTPS, SMB. Kein einziger Eintrag sieht auf den ' +
                        'ersten Blick falsch aus – schau auf Muster und Ziele.',
                    logs:
'=================================================================================\n' +
' FW-CORE   Protokoll 02:10–02:40   Host WEB-01 = 10.20.0.15\n' +
'=================================================================================\n' +
' Nr  Zeit      Ri   Ziel                 Port  Aktion  Volumen  Notiz\n' +
'---------------------------------------------------------------------------------\n' +
' 01  02:10:04  aus  10.20.0.1            53    ALLOW   0,3 KB   DNS A  api.wetter.de\n' +
' 02  02:10:33  aus  10.20.0.1            53    ALLOW   1,2 KB   DNS TXT  k3n8f2.sync-cdn-telemetry.net\n' +
' 03  02:11:00  aus  52.112.120.60        443   ALLOW   900 KB   teams.microsoft.com\n' +
' 04  02:11:34  aus  10.20.0.1            53    ALLOW   1,2 KB   DNS TXT  p9a1c7.sync-cdn-telemetry.net\n' +
' 05  02:12:00  aus  193.42.33.80         443   ALLOW   2 KB     TLS\n' +
' 06  02:12:35  aus  10.20.0.1            53    ALLOW   1,2 KB   DNS TXT  z4m6b0.sync-cdn-telemetry.net\n' +
' 07  02:13:20  aus  10.20.0.10           445   ALLOW   68 KB    SMB  \\\\DC01\\C$\n' +
' 08  02:14:00  aus  91.189.91.43         123   ALLOW   0,1 KB   NTP\n' +
' 09  02:15:36  aus  10.20.0.1            53    ALLOW   1,2 KB   DNS TXT  t1x9q2.sync-cdn-telemetry.net\n' +
' 10  02:17:00  aus  193.42.33.80         443   ALLOW   2 KB     TLS\n' +
' 11  02:18:05  aus  20.190.160.14        443   ALLOW   140 KB   update.microsoft.com\n' +
' 12  02:19:37  aus  10.20.0.1            53    ALLOW   1,2 KB   DNS TXT  w8e3r5.sync-cdn-telemetry.net\n' +
' 13  02:22:00  aus  193.42.33.80         443   ALLOW   2 KB     TLS\n' +
' 14  02:23:14  aus  10.20.0.20           445   ALLOW   52 KB    SMB  \\\\FILESRV01\\backup   (Sicherung)',
                    pruefpunkte: [
                        {gefahr: true, text: 'Nr. 02/04/06/09/12 – laufend DNS-TXT-Anfragen an zufällige ' +
                            'Subdomains von sync-cdn-telemetry.net.',
                         erklaerung: 'Viele TXT-Anfragen mit wechselnden, zufälligen Subdomains an dieselbe ' +
                            'fremde Domain sind DNS-Tunneling: Daten werden in den Anfragenamen nach außen ' +
                            'geschmuggelt. DNS ist erlaubt, fällt also kaum auf – genau das ist der Trick.'},
                        {gefahr: true, text: 'Nr. 05/10/13 – alle 5 Minuten 2 KB über 443 zu 193.42.33.80.',
                         erklaerung: 'Ein Beacon muss nicht auf einem auffälligen Port liegen. Gleiche ' +
                            'kleine Größe im festen 300-Sekunden-Takt zu einer unbekannten Adresse ist C2 ' +
                            'über HTTPS – getarnt zwischen echtem Web-Verkehr.'},
                        {gefahr: true, text: 'Nr. 07 – SMB (445) von WEB-01 zu DC01 (10.20.0.10), Zugriff auf C$.',
                         erklaerung: 'Ein Webserver hat am Domaincontroller per SMB nichts zu suchen. Zugriff ' +
                            'auf die administrative Freigabe C$ deutet auf Lateral Movement mit erbeuteten ' +
                            'Zugangsdaten hin.'},
                        {gefahr: false, text: 'Nr. 14 – SMB (445) zu FILESRV01\\backup, als Sicherung markiert.',
                         erklaerung: 'SMB an sich ist nicht böse. Eine geplante Sicherung auf den dafür ' +
                            'vorgesehenen Dateiserver ist erwartbarer Verkehr – im Gegensatz zum Zugriff auf C$ am DC.'},
                        {gefahr: false, text: 'Nr. 03 – 900 KB zu teams.microsoft.com auf 443.',
                         erklaerung: 'Bekannter Microsoft-Dienst, normaler HTTPS-Verkehr.'},
                        {gefahr: false, text: 'Nr. 01 – DNS-A-Anfrage für api.wetter.de.',
                         erklaerung: 'Eine einzelne, normale Namensauflösung – kein Tunneling-Muster.'}
                    ]
                },

                /* ---- Runde 3: legitime Dienste missbraucht (living off the land) ---- */
                {
                    label: 'Legitime Dienste als Tarnung',
                    intro: 'Jetzt wird es unangenehm: Der Angreifer missbraucht völlig legitime ' +
                        'Cloud-Dienste wie GitHub und Google Drive. Jede Verbindung für sich ist ' +
                        'unverdächtig – man sieht es nur am Rhythmus und daran, was ein Webserver ' +
                        'normalerweise eben nicht tut.',
                    logs:
'=================================================================================\n' +
' FW-CORE   Protokoll 11:00–11:45   Host WEB-01 = 10.20.0.15\n' +
'=================================================================================\n' +
' Nr  Zeit      Ri   Ziel                      Port  Vol     Notiz\n' +
'---------------------------------------------------------------------------------\n' +
' 01  11:00:12  aus  140.82.121.3 (github.com) 443   24 KB   git fetch  repo: firmen-cms\n' +
' 02  11:03:40  aus  185.199.108.133           443   3 KB    raw.githubusercontent.com/gist/..\n' +
' 03  11:08:40  aus  185.199.108.133           443   3 KB    raw.githubusercontent.com/gist/..\n' +
' 04  11:10:05  aus  151.101.0.69 (pypi)       443   2 MB    pip install reportlab\n' +
' 05  11:13:40  aus  185.199.108.133           443   3 KB    raw.githubusercontent.com/gist/..\n' +
' 06  11:16:20  aus  104.18.22.19              443   30 MB   cdn.jsdelivr.net\n' +
' 07  11:18:40  aus  185.199.108.133           443   3 KB    raw.githubusercontent.com/gist/..\n' +
' 08  11:20:11  aus  142.250.74.196            443   45 KB   POST  drive.google.com/upload (img001)\n' +
' 09  11:25:17  aus  142.250.74.196            443   47 KB   POST  drive.google.com/upload (img002)\n' +
' 10  11:30:22  aus  142.250.74.196            443   46 KB   POST  drive.google.com/upload (img003)\n' +
' 11  11:33:00  aus  20.190.160.14             443   160 KB  update.microsoft.com\n' +
' 12  11:35:28  aus  142.250.74.196            443   47 KB   POST  drive.google.com/upload (img004)\n' +
' 13  11:40:33  aus  142.250.74.196            443   46 KB   POST  drive.google.com/upload (img005)',
                    pruefpunkte: [
                        {gefahr: true, text: 'Nr. 02/03/05/07 – alle 5 Minuten 3 KB von raw.githubusercontent.com (Gist).',
                         erklaerung: 'GitHub ist legitim – aber ein Server, der im festen Takt winzige Dateien ' +
                            'von einem Raw-Gist abruft, nutzt die Plattform als C2-Kanal („dead drop"). Verdächtig ' +
                            'ist das Muster, nicht das Ziel.'},
                        {gefahr: true, text: 'Nr. 08–13 – alle 5 Minuten ~46 KB „Bild-Uploads" zu Google Drive.',
                         erklaerung: 'Gleich große „Bilder" in strikt regelmäßigem Takt zu einem Cloud-Speicher ' +
                            'sind getarnte Exfiltration: Daten werden häppchenweise als harmlose Uploads ' +
                            'ausgeschleust. Die Regelmäßigkeit verrät die Automatik.'},
                        {gefahr: false, text: 'Nr. 01 – git fetch des eigenen Firmen-CMS von github.com.',
                         erklaerung: 'Ein einzelner, zweckgebundener Abruf des eigenen Repositories ist normaler ' +
                            'Deploy-Verkehr – kein Takt, klarer Zweck.'},
                        {gefahr: false, text: 'Nr. 04 – pip install reportlab von PyPI.',
                         erklaerung: 'Paketinstallation von der offiziellen Python-Quelle. Unauffällig, solange ' +
                            'es nicht in ein verdächtiges Muster eingebettet ist.'},
                        {gefahr: false, text: 'Nr. 06 – 30 MB von cdn.jsdelivr.net.',
                         erklaerung: 'Normaler CDN-Download. Volumen ohne auffälliges Muster ist kein Alarm.'}
                    ]
                },

                /* ---- Runde 4: minimal, mit Jitter und zu ungewöhnlicher Zeit ---- */
                {
                    label: 'Fast unsichtbar',
                    intro: 'Der letzte Fall ist auf dem Niveau, das dich im Ernstfall erwartet: ' +
                        'minimal, mit unregelmäßigem Takt, nachts, kaum Volumen, zwischen echtem ' +
                        'CDN- und Backup-Verkehr. Hier trennt sich geschultes Auge von Zufall.',
                    logs:
'=================================================================================\n' +
' FW-CORE   Protokoll 03:00–04:30   Host WEB-01 = 10.20.0.15   (Nacht, kaum Betrieb)\n' +
'=================================================================================\n' +
' Nr  Zeit      Ri   Ziel                      Port  Vol     Notiz\n' +
'---------------------------------------------------------------------------------\n' +
' 01  03:02:11  aus  91.189.91.43              123   0,1 KB  NTP\n' +
' 02  03:05:40  aus  152.199.19.161            443   1,5 KB  azureedge.net (CDN)\n' +
' 03  03:12:06  aus  45.9.148.37               443   1,8 KB  TLS  (erstmals gesehen)\n' +
' 04  03:30:00  aus  10.20.0.5                 3306  12 KB   MySQL  Backup-Job\n' +
' 05  03:46:52  aus  45.9.148.37               443   1,7 KB  TLS\n' +
' 06  04:01:00  aus  20.190.160.14             443   150 KB  update.microsoft.com\n' +
' 07  04:18:39  aus  45.9.148.37               443   1,9 KB  TLS\n' +
' 08  04:20:03  aus  152.199.19.161            443   2,1 KB  azureedge.net (CDN)\n' +
' 09  04:25:00  aus  142.250.74.196            443   900 KB  backup-fotos.google.com (geplant)\n' +
' 10  04:29:14  aus  45.9.148.37               443   1,6 KB  TLS',
                    pruefpunkte: [
                        {gefahr: true, text: 'Nr. 03/05/07/10 – kleine TLS-Verbindungen zu 45.9.148.37, ' +
                            'ungefähr alle 15–16 Minuten, erstmals gesehenes Ziel.',
                         erklaerung: 'Hier gibt es keinen Port-4444-Volltreffer: kleines Volumen, Standardport ' +
                            '443, und der Abstand ist nicht exakt, sondern schwankt (Jitter: 15–16 min) – genau ' +
                            'um Muster-Erkennung zu umgehen. Verräterisch bleiben das neue, unbekannte Ziel und ' +
                            'die trotz Jitter erkennbare Wiederkehr. Das ist fortgeschrittenes C2-Beaconing.'},
                        {gefahr: false, text: 'Nr. 02/08 – azureedge.net auf 443.',
                         erklaerung: 'Bekanntes Microsoft-CDN, kleines Volumen, kein auffälliges Muster.'},
                        {gefahr: false, text: 'Nr. 09 – 900 KB zu backup-fotos.google.com, als geplant markiert.',
                         erklaerung: 'Eine einmalige, als geplant gekennzeichnete Sicherung. Ohne Takt und mit ' +
                            'klarem Zweck unauffällig – im Gegensatz zum regelmäßigen Beacon in Nr. 03/05/07/10.'},
                        {gefahr: false, text: 'Nr. 04 – MySQL (3306) zu 10.20.0.5, Backup-Job.',
                         erklaerung: 'Interner Datenbank-Backup-Verkehr zur erwarteten Zeit. Normal.'}
                    ]
                }

            ],
            abschlussfragen: [
                {
                    frage: 'Quer durch alle vier Fälle: Woran erkennst du solche Aktivität im Log am ' +
                        'zuverlässigsten?',
                    optionen: [
                        'Am Datenvolumen – große Transfers sind das sicherste Warnzeichen.',
                        'Am Muster und am Kontext: regelmäßige Wiederkehr, unbekannte Ziele und ' +
                            'Verhalten, das für diesen Host untypisch ist – nicht an einem einzelnen Merkmal.',
                        'An der Ziel-Adresse: Verbindungen ins Ausland sind das Hauptkriterium.'
                    ],
                    richtig: 1,
                    erklaerung: 'Kein einzelnes Merkmal reicht: Der harmlose CDN-Download war groß, das ' +
                        'gefährliche Beaconing winzig; C2 lief mal auf Port 4444, mal getarnt über 443, DNS ' +
                        'oder GitHub. Was die Angriffe verbindet, ist das Muster (regelmäßige Wiederkehr, oft ' +
                        'mit Jitter), ein unbekanntes Ziel und Verhalten, das für diesen Host untypisch ist. ' +
                        'Deshalb braucht gute Erkennung eine Vorstellung vom Normalzustand – ein Baseline.'
                },
                {
                    frage: 'Und im Arbeitsalltag: Womit fällt so etwas realistisch auf, bevor es ' +
                        'jemand zufällig per Hand im Log entdeckt?',
                    optionen: [
                        'Die Firewall regelt das selbst – sie blockt verdächtigen Verkehr automatisch.',
                        'Gar nicht zuverlässig – man muss die Logs eben regelmäßig manuell durchsehen.',
                        'Durch zentrale, laufende Auswertung (SIEM/Monitoring) mit Alarmen auf Muster ' +
                            'und Abweichungen vom Normalzustand – und jemanden, der sie bewertet, ' +
                            'idealerweise rund um die Uhr in einem SOC.'
                    ],
                    richtig: 2,
                    erklaerung: 'Die Firewall hat in allen vier Fällen „ALLOW" protokolliert – der ' +
                        'Verkehr sah erlaubt aus, sie blockt so etwas also nicht von allein. Und alle ' +
                        'Logs von Hand zu lesen, skaliert im Alltag nicht. Was in der Praxis trägt: Logs ' +
                        'laufen zentral zusammen (SIEM), werden gegen einen bekannten Normalzustand ' +
                        'geprüft, und auf Muster wie Beaconing, neue Ziele oder ungewöhnliche Datenmengen ' +
                        'gibt es automatische Alarme – die dann ein Mensch bewertet. Genau das leistet ' +
                        'ein Security Operations Center.'
                }
            ],
            ergebnis: {
                gut: 'Durchgespielt – vom offensichtlichen Port 4444 bis zum Beacon mit Jitter. Genau ' +
                    'dieser geschulte Blick, kombiniert mit einem Gefühl für den Normalzustand, trennt ' +
                    'im Ernstfall Fehlalarm von echtem Vorfall.',
                mittel: 'Solide, aber in den schwereren Fällen sind Spuren durchgerutscht – oder ' +
                    'Harmloses wurde als Angriff gewertet. Beides kostet: das eine lässt Angriffe durch, ' +
                    'das andere bindet Zeit.',
                schwach: 'Die späteren Fälle sind bewusst hart: getarnt über legitime Dienste, mit Jitter, ' +
                    'nachts. Genau darauf setzen echte Angreifer – und genau das lässt sich trainieren.'
            }
        }

    };

    var slug = root.getAttribute('data-challenge');
    var szenario = SZENARIEN[slug];
    if (!szenario) {
        return;
    }

    var prefersReduce = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function el(tag, cls, html) {
        var e = document.createElement(tag);
        if (cls) { e.className = cls; }
        if (html != null) { e.innerHTML = html; }
        return e;
    }

    function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
            return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
        });
    }

    /* ---------------------------------------------------------------- Quiz */

    function renderQuiz() {
        root.innerHTML = '';

        var intro = el('p', 'chl-intro', szenario.intro);
        root.appendChild(intro);

        if (szenario.logs) {
            var pre = el('pre', 'chl-logs');
            pre.setAttribute('aria-label', 'Logauszug');
            pre.textContent = szenario.logs;
            root.appendChild(pre);
        }

        var state = {antworten: [], aktuell: 0};
        var frageBox = el('div', 'chl-questions');
        root.appendChild(frageBox);

        function zeigeFrage(i) {
            var f = szenario.fragen[i];
            frageBox.innerHTML = '';

            var kopf = el('p', 'chl-step', 'Frage ' + (i + 1) + ' von ' + szenario.fragen.length);
            frageBox.appendChild(kopf);
            frageBox.appendChild(el('h3', 'chl-frage', escapeHtml(f.frage)));

            var liste = el('div', 'chl-options');
            f.optionen.forEach(function (opt, idx) {
                var btn = el('button', 'chl-option');
                btn.type = 'button';
                btn.textContent = opt;
                btn.addEventListener('click', function () {
                    waehle(i, idx, liste, f);
                });
                liste.appendChild(btn);
            });
            frageBox.appendChild(liste);
        }

        function waehle(frageIdx, optIdx, liste, f) {
            if (state.antworten[frageIdx] != null) {
                return; // schon beantwortet
            }
            state.antworten[frageIdx] = optIdx;

            var buttons = liste.querySelectorAll('.chl-option');
            Array.prototype.forEach.call(buttons, function (b, idx) {
                b.disabled = true;
                if (idx === f.richtig) { b.classList.add('is-correct'); }
                else if (idx === optIdx) { b.classList.add('is-wrong'); }
            });

            var erkl = el('div', 'chl-explain ' + (optIdx === f.richtig ? 'is-correct' : 'is-wrong'));
            erkl.innerHTML = '<strong>' + (optIdx === f.richtig ? 'Richtig.' : 'Daneben.') +
                '</strong> ' + escapeHtml(f.erklaerung);
            liste.insertAdjacentElement('afterend', erkl);

            var weiter = el('button', 'as-btn as-btn-primary chl-next');
            weiter.type = 'button';
            weiter.textContent = (frageIdx + 1 < szenario.fragen.length) ? 'Weiter' : 'Auswertung';
            weiter.addEventListener('click', function () {
                if (frageIdx + 1 < szenario.fragen.length) {
                    zeigeFrage(frageIdx + 1);
                } else {
                    auswerten(state);
                }
            });
            erkl.appendChild(weiter);
        }

        zeigeFrage(0);
    }

    function auswerten(state) {
        var richtig = state.antworten.filter(function (a, i) {
            return a === szenario.fragen[i].richtig;
        }).length;
        zeigeErgebnis(richtig, szenario.fragen.length);
    }

    /* -------------------------------------------------------- Checklist-Helfer */

    // Zeigt eine Mail als reine Anzeige (nichts anklickbar). Der Link verrät
    // sein echtes Ziel nur beim Überfahren über eine Statusleiste.
    function baueMail(container, mailHtml) {
        var mail = el('div', 'chl-mail');
        mail.innerHTML = mailHtml;
        container.appendChild(mail);

        var statusbar = el('div', 'chl-statusbar');
        function resetZiel() {
            statusbar.innerHTML = '<span class="chl-statusbar-idle">Fahre über den Link, ' +
                'um sein echtes Ziel zu sehen</span>';
        }
        resetZiel();
        container.appendChild(statusbar);

        mail.addEventListener('click', function (e) {
            var a = e.target.closest ? e.target.closest('a') : null;
            if (a) { e.preventDefault(); }
        });

        Array.prototype.forEach.call(mail.querySelectorAll('[data-real]'), function (lnk) {
            var url = lnk.getAttribute('data-real');
            function show() {
                statusbar.innerHTML = '<span class="chl-statusbar-k">Echtes Ziel:</span> ' +
                    '<span class="chl-statusbar-url">' + escapeHtml(url) + '</span>';
            }
            lnk.setAttribute('tabindex', '0');
            lnk.addEventListener('mouseenter', show);
            lnk.addEventListener('mouseleave', resetZiel);
            lnk.addEventListener('focus', show);
            lnk.addEventListener('blur', resetZiel);
        });
    }

    // Aufklappbare E-Mail-Header, bewusst ÜBER der Mail (wie im Mailprogramm).
    function baueHeaderToggle(container, headerText) {
        var toggle = el('button', 'as-btn chl-header-toggle');
        toggle.type = 'button';
        toggle.textContent = 'E-Mail-Header anzeigen';
        var hdr = el('pre', 'chl-logs is-hidden');
        hdr.textContent = headerText;
        toggle.addEventListener('click', function () {
            hdr.classList.toggle('is-hidden');
            var offen = !hdr.classList.contains('is-hidden');
            toggle.textContent = offen ? 'E-Mail-Header ausblenden' : 'E-Mail-Header anzeigen';
        });
        container.appendChild(toggle);
        container.appendChild(hdr);
    }

    function baueLog(container, logText) {
        var pre = el('pre', 'chl-logs');
        pre.setAttribute('aria-label', 'Protokollauszug');
        pre.textContent = logText;
        container.appendChild(pre);
    }

    // Baut die Ankreuzliste samt Auswerten-Knopf. onSubmit bekommt {idx:bool}.
    function baueChecklisteForm(container, pruefpunkte, buttonLabel, onSubmit) {
        container.appendChild(el('p', 'chl-check-frage', 'Was davon ist gefährlich? Kreuze alles ' +
            'an, was du für ein echtes Warnzeichen hältst.'));

        var form = el('form', 'chl-checklist');
        pruefpunkte.forEach(function (pp, idx) {
            var id = 'chl-pp-' + idx;
            var row = el('label', 'chl-check');
            row.setAttribute('for', id);
            row.innerHTML =
                '<input type="checkbox" id="' + id + '" data-idx="' + idx + '">' +
                '<span class="chl-check-text">' + escapeHtml(pp.text) + '</span>';
            form.appendChild(row);
        });
        container.appendChild(form);

        var btn = el('button', 'as-btn as-btn-primary chl-next');
        btn.type = 'button';
        btn.textContent = buttonLabel || 'Auswerten';
        btn.addEventListener('click', function () {
            var gewaehlt = {};
            Array.prototype.forEach.call(form.querySelectorAll('input[type=checkbox]'), function (cb) {
                gewaehlt[parseInt(cb.getAttribute('data-idx'), 10)] = cb.checked;
            });
            onSubmit(gewaehlt);
        });
        container.appendChild(btn);
    }

    // Rendert die Auflösung einer Ankreuzliste und liefert die Bilanz zurück.
    function zeigeChecklistAufloesung(container, pruefpunkte, gewaehlt) {
        var gefahren = pruefpunkte.filter(function (p) { return p.gefahr; }).length;
        var treffer = 0, fehlalarm = 0;

        var liste = el('div', 'chl-solution');
        pruefpunkte.forEach(function (p, idx) {
            var g = !!gewaehlt[idx];
            var korrekt = g === p.gefahr;
            if (p.gefahr && g) { treffer++; }
            if (!p.gefahr && g) { fehlalarm++; }

            var cls = korrekt ? 'is-found' : 'is-missed';
            var mark = korrekt ? '✓' : '✕';
            var label = p.gefahr ? 'Gefährlich' : 'Harmlos';
            var zusatz = '';
            if (!korrekt && p.gefahr) { zusatz = ' – übersehen'; }
            if (!korrekt && !p.gefahr) { zusatz = ' – Fehlalarm'; }

            var item = el('div', 'chl-sol-item ' + cls);
            item.innerHTML =
                '<span class="chl-sol-mark">' + mark + '</span>' +
                '<div><strong>' + escapeHtml(label + zusatz) + ':</strong> ' +
                escapeHtml(p.text) +
                '<p>' + escapeHtml(p.erklaerung) + '</p></div>';
            liste.appendChild(item);
        });
        container.appendChild(liste);

        return {treffer: treffer, gefahren: gefahren, fehlalarm: fehlalarm};
    }

    function scrollZumAnfang() {
        if (!prefersReduce && root.scrollIntoView) {
            root.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }

    // Spielt eine Fragerunde: Fragen nacheinander mit Auswahl, Markierung und
    // Erklärung. Ruft am Ende onFertig(anzahlRichtig) auf. buttonLast steuert
    // die Beschriftung des Knopfes nach der letzten Frage.
    function spieleQuiz(container, fragen, buttonLast, onFertig) {
        var antworten = [];
        var box = el('div', 'chl-questions');
        container.appendChild(box);

        function zeige(idx) {
            box.innerHTML = '';
            var f = fragen[idx];
            box.appendChild(el('p', 'chl-step', 'Frage ' + (idx + 1) + ' von ' + fragen.length));
            box.appendChild(el('h3', 'chl-frage', escapeHtml(f.frage)));

            var liste = el('div', 'chl-options');
            f.optionen.forEach(function (opt, oi) {
                var b = el('button', 'chl-option');
                b.type = 'button';
                b.textContent = opt;
                b.addEventListener('click', function () { waehle(idx, oi, liste, f); });
                liste.appendChild(b);
            });
            box.appendChild(liste);
        }

        function waehle(idx, oi, liste, f) {
            if (antworten[idx] != null) { return; }
            antworten[idx] = oi;
            var bs = liste.querySelectorAll('.chl-option');
            Array.prototype.forEach.call(bs, function (b, bi) {
                b.disabled = true;
                if (bi === f.richtig) { b.classList.add('is-correct'); }
                else if (bi === oi) { b.classList.add('is-wrong'); }
            });
            var erkl = el('div', 'chl-explain ' + (oi === f.richtig ? 'is-correct' : 'is-wrong'));
            erkl.innerHTML = '<strong>' + (oi === f.richtig ? 'Richtig.' : 'Daneben.') +
                '</strong> ' + escapeHtml(f.erklaerung);
            liste.insertAdjacentElement('afterend', erkl);

            var last = idx + 1 >= fragen.length;
            var next = el('button', 'as-btn as-btn-primary chl-next');
            next.type = 'button';
            next.textContent = last ? (buttonLast || 'Weiter') : 'Nächste Frage';
            next.addEventListener('click', function () {
                if (!last) { zeige(idx + 1); }
                else {
                    var richtig = antworten.filter(function (a, k) {
                        return a === fragen[k].richtig;
                    }).length;
                    onFertig(richtig);
                }
            });
            erkl.appendChild(next);
        }

        zeige(0);
    }

    /* ----------------------------------------------------------- Checklist
     * Einzelne Ankreuzrunde (Phishing): Header oben, Mail, dann Checkliste.
     */
    function renderChecklist() {
        root.innerHTML = '';
        root.appendChild(el('p', 'chl-intro', szenario.intro));

        if (szenario.header) { baueHeaderToggle(root, szenario.header); }
        if (szenario.mailHtml) { baueMail(root, szenario.mailHtml); }
        if (szenario.logs) { baueLog(root, szenario.logs); }

        baueChecklisteForm(root, szenario.pruefpunkte, 'Auswerten', function (gewaehlt) {
            root.innerHTML = '';
            root.appendChild(el('p', 'chl-step', 'Auflösung'));
            var erg = zeigeChecklistAufloesung(root, szenario.pruefpunkte, gewaehlt);
            var bilanz = erg.treffer + ' von ' + erg.gefahren + ' Gefahren erkannt';
            if (erg.fehlalarm > 0) {
                bilanz += ', ' + erg.fehlalarm + ' Fehlalarm' + (erg.fehlalarm > 1 ? 'e' : '');
            }
            zeigeErgebnis(Math.max(0, erg.treffer - erg.fehlalarm), erg.gefahren, bilanz);
        });
    }

    /* -------------------------------------------------------------- Serie
     * Mehrere Logs nacheinander, von Fall zu Fall schwerer. Nach dem
     * Auswerten je Runde die Auflösung + "Weiter", am Ende eine
     * Abschlussfrage und ein Gesamtergebnis über alle Runden.
     */
    function renderSerie() {
        var runden = szenario.runden;
        var acc = {treffer: 0, gefahren: 0, fehlalarm: 0};

        var einheit = szenario.einheit || 'Fall';

        // Knopf, der zur nächsten Runde oder zur Abschlussfrage führt.
        function weiterKnopf(i, container) {
            var letzte = i + 1 >= runden.length;
            var weiter = el('button', 'as-btn as-btn-primary chl-next');
            weiter.type = 'button';
            weiter.textContent = letzte
                ? 'Zur Abschlussfrage' : 'Weiter zum nächsten ' + einheit;
            weiter.addEventListener('click', function () {
                if (letzte) { zeigeAbschlussfrage(0); } else { zeigeRunde(i + 1); }
                scrollZumAnfang();
            });
            container.appendChild(weiter);
        }

        function zeigeRunde(i) {
            root.innerHTML = '';
            var runde = runden[i];
            root.appendChild(el('p', 'chl-step', einheit + ' ' + (i + 1) + ' von ' + runden.length +
                (runde.label ? ' · ' + runde.label : '')));
            var introText = runde.intro || (i === 0 ? szenario.intro : '');
            if (introText) {
                root.appendChild(el('p', 'chl-intro', introText));
            }

            // Anzeige: Mail (mit optionalen Headern oben) oder Log.
            if (runde.mailHtml) {
                if (runde.header) { baueHeaderToggle(root, runde.header); }
                baueMail(root, runde.mailHtml);
            } else if (runde.logs) {
                baueLog(root, runde.logs);
            }

            // Interaktion: Fragerunde (quiz) oder Ankreuzliste (checklist).
            if (runde.fragen) {
                spieleQuiz(root, runde.fragen, 'Auflösung', function (richtig) {
                    acc.treffer += richtig;
                    acc.gefahren += runde.fragen.length;
                    root.innerHTML = '';
                    root.appendChild(el('p', 'chl-step',
                        'Ergebnis · ' + einheit + ' ' + (i + 1)));
                    root.appendChild(el('p', 'chl-result-text',
                        richtig + ' von ' + runde.fragen.length + ' Fragen richtig.'));
                    weiterKnopf(i, root);
                    scrollZumAnfang();
                });
            } else {
                baueChecklisteForm(root, runde.pruefpunkte, 'Auswerten', function (gewaehlt) {
                    root.innerHTML = '';
                    root.appendChild(el('p', 'chl-step', 'Auflösung · ' + einheit + ' ' + (i + 1)));
                    var erg = zeigeChecklistAufloesung(root, runde.pruefpunkte, gewaehlt);
                    acc.treffer += erg.treffer;
                    acc.gefahren += erg.gefahren;
                    acc.fehlalarm += erg.fehlalarm;
                    weiterKnopf(i, root);
                    scrollZumAnfang();
                });
            }
        }

        function zeigeAbschlussfrage(qi) {
            // Unterstützt mehrere Abschlussfragen (Array) und die alte Einzelform.
            var fragen = szenario.abschlussfragen ||
                (szenario.abschlussfrage ? [szenario.abschlussfrage] : []);
            if (qi >= fragen.length) { zeigeGesamt(); return; }

            root.innerHTML = '';
            var f = fragen[qi];
            var mehr = fragen.length > 1 ? ' ' + (qi + 1) + ' von ' + fragen.length : '';
            root.appendChild(el('p', 'chl-step', 'Abschlussfrage' + mehr));
            root.appendChild(el('h3', 'chl-frage', escapeHtml(f.frage)));

            var liste = el('div', 'chl-options');
            f.optionen.forEach(function (opt, oidx) {
                var btn = el('button', 'chl-option');
                btn.type = 'button';
                btn.textContent = opt;
                btn.addEventListener('click', function () {
                    var bs = liste.querySelectorAll('.chl-option');
                    Array.prototype.forEach.call(bs, function (b, bi) {
                        b.disabled = true;
                        if (bi === f.richtig) { b.classList.add('is-correct'); }
                        else if (bi === oidx) { b.classList.add('is-wrong'); }
                    });
                    var erkl = el('div', 'chl-explain ' + (oidx === f.richtig ? 'is-correct' : 'is-wrong'));
                    erkl.innerHTML = '<strong>' + (oidx === f.richtig ? 'Richtig.' : 'Daneben.') +
                        '</strong> ' + escapeHtml(f.erklaerung);
                    liste.insertAdjacentElement('afterend', erkl);

                    var letzte = qi + 1 >= fragen.length;
                    var naechster = el('button', 'as-btn as-btn-primary chl-next');
                    naechster.type = 'button';
                    naechster.textContent = letzte ? 'Gesamtergebnis' : 'Nächste Frage';
                    naechster.addEventListener('click', function () {
                        if (letzte) { zeigeGesamt(); } else { zeigeAbschlussfrage(qi + 1); }
                        scrollZumAnfang();
                    });
                    erkl.appendChild(naechster);
                });
                liste.appendChild(btn);
            });
            root.appendChild(liste);
        }

        function zeigeGesamt() {
            root.innerHTML = '';
            root.appendChild(el('p', 'chl-step', 'Gesamtergebnis'));
            var bilanz = acc.treffer + ' von ' + acc.gefahren + ' insgesamt erkannt';
            if (acc.fehlalarm > 0) {
                bilanz += ', ' + acc.fehlalarm + ' Fehlalarm' + (acc.fehlalarm > 1 ? 'e' : '');
            }
            zeigeErgebnis(Math.max(0, acc.treffer - acc.fehlalarm), acc.gefahren, bilanz);
        }

        zeigeRunde(0);
    }

    /* ------------------------------------------------------------- Ergebnis */

    function zeigeErgebnis(richtig, gesamt, bilanz) {
        var anteil = gesamt > 0 ? richtig / gesamt : 0;
        var titel, text;
        // bilanz überschreibt den Standard-Zähler (für die Checkliste mit Fehlalarmen).
        var kopf = bilanz || (richtig + ' von ' + gesamt);
        if (anteil >= 0.8) {
            titel = kopf + ' – stark.';
            text = szenario.ergebnis.gut;
        } else if (anteil >= 0.4) {
            titel = kopf + ' – solide, mit Lücken.';
            text = szenario.ergebnis.mittel;
        } else {
            titel = kopf + '.';
            text = szenario.ergebnis.schwach;
        }

        var box = el('div', 'chl-result');
        box.innerHTML =
            '<p class="chl-result-score">' + escapeHtml(titel) + '</p>' +
            '<p class="chl-result-text">' + escapeHtml(text) + '</p>';
        root.appendChild(box);

        // Vorhandenen CTA-Block (im Template) einblenden, falls vorhanden
        var cta = document.querySelector('[data-challenge-cta]');
        if (cta) {
            cta.classList.remove('is-hidden');
            if (!prefersReduce) {
                cta.scrollIntoView({behavior: 'smooth', block: 'nearest'});
            }
        }
    }

    /* ---------------------------------------------------------------- Start */

    if (szenario.typ === 'serie') {
        renderSerie();
    } else if (szenario.typ === 'checklist') {
        renderChecklist();
    } else {
        renderQuiz();
    }
})();
